module.exports = __webpack_public_path__ + "static/contractor-cob-11dacd9372716e5e9e528286bdf21d68.png";